import { render, staticRenderFns } from "./Thumbnail.vue?vue&type=template&id=fdfded9e&scoped=true&"
import script from "./Thumbnail.vue?vue&type=script&lang=js&"
export * from "./Thumbnail.vue?vue&type=script&lang=js&"
import style0 from "./Thumbnail.vue?vue&type=style&index=0&id=fdfded9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfded9e",
  null
  
)

export default component.exports